<template>
    <div class="status-counter">
        <div class="border-general border-todo" :id="`status-couter-todo-${idTextAppend}`">
            {{ statusCounter.toDo || 0 }}
            <b-tooltip :target="`status-couter-todo-${idTextAppend}`"> {{ $t('notStartedInitiatives') }} </b-tooltip>
        </div>
        <div class="border-general border-doing" :id="`status-couter-doing-${idTextAppend}`">
            {{ statusCounter.doing || 0 }}
            <b-tooltip :target="`status-couter-doing-${idTextAppend}`"> {{ $t('inProgressInitiatives') }} </b-tooltip>
        </div>
        <div class="border-general border-done" :id="`status-couter-done-${idTextAppend}`">
            {{ statusCounter.done || 0 }}
            <b-tooltip :target="`status-couter-done-${idTextAppend}`"> {{ $t('completedInitiatives') }} </b-tooltip>
        </div>
    </div>
</template>

<script>
export default {
    name: 'StatusCounter',
    props: {
        statusCounter: {
            type: Object,
        },
        idTextAppend: {
            type: String,
        },
    },
    i18n: {
        messages: {
            'en-US': {
                notStartedInitiatives: 'Not Started Initiatives',
                inProgressInitiatives: 'In Progress Initiatives',
                completedInitiatives: 'Completed Initiatives',
            },
            'es-ES': {
                notStartedInitiatives: 'Iniciativas No Empezado',
                inProgressInitiatives: 'Iniciativas En Curso',
                completedInitiatives: 'Iniciativas Completadas',
            },
            'pt-BR': {
                notStartedInitiatives: 'Iniciativas Não Iniciadas',
                inProgressInitiatives: 'Iniciativas Em Andamento',
                completedInitiatives: 'Iniciativas Finalizadas',
            },
        },
    },
}
</script>
<style scoped>
.status-counter {
    display: flex;
    gap: 0.5rem;
}
.border-general {
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 3px solid;
    width: 1.5rem;
}
.border-todo {
    border-color: #f86c6b !important;
    color: #f86c6b;
}
.border-doing {
    border-color: #ffc107 !important;
    color: #ffc107;
}
.border-done {
    border-color: #4dbd74 !important;
    color: #4dbd74;
}
</style>
